"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClientAdapter = void 0;
var siteAssetsClientErrors_1 = require("./domain/siteAssetsClientErrors");
var httpHelper_1 = require("./helper/httpHelper");
exports.HttpClientAdapter = function (httpClient, moduleMetricsReporter) {
    var reject = function (msg, err) {
        return Promise.reject(new siteAssetsClientErrors_1.HttpClientFetchError(msg, err));
    };
    var call = function (httpHandler) {
        try {
            return httpClient.fetch(httpHandler.requestUrl, httpHandler.requestInit)
                .then(httpHandler.transformResponse)
                .catch(function (httpResponseError) {
                if (httpHelper_1.isAxiosStyleError(httpResponseError)) {
                    return reject(httpHandler.rejectMessage(httpResponseError.response.status, httpResponseError.response.data));
                }
                return reject('http client rejected request', httpResponseError);
            })
                .then(function (httpResponse) {
                if (!httpResponse.rawHttpResponse.ok) {
                    return httpHandler.extractErrorMessage(httpResponse).then(reject);
                }
                httpResponse.reportMetrics(moduleMetricsReporter);
                return httpResponse;
            });
        }
        catch (httpClientError) {
            return Promise.reject(new siteAssetsClientErrors_1.UnexpectedHttpClientError(httpClientError));
        }
    };
    return {
        call: call
    };
};
